import axios from 'axios';

const baseUrl = process.env.REACT_APP_URL_SERVER;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const ProductsData = {

  /**
   * A partir de las siguientes funciones obtenemos los datos de la calculadora.
   */
  getRates: (type) => {
    const response = axios({
      url: `${baseUrl}/api/cfe/rates/${type}?code=${apiCode}`,
      method: 'GET',
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  /**
   * Obtiene todos los productos CNC con su consumo y medidas
   */
  getProducts: () => {
    const response = axios({
      url: `${baseUrl}/api/products/byConsumption?code=${apiCode}`,
      method: 'GET',
    })
      .then((res) => {
        const data = res.data.productos.map((product) => (
          {
            name: `${product.nombre_producto} - ${product.modelo_interno}`,
            productModel: product.modelo_interno,
            shopifyPrice: product.precio_shopify,
            url: product.imgurls,
            witdhCut: product.corte_ancho,
            lengthCut: product.corte_largo,
            id: product.id_producto,
          }
        ));
        data.sort((a, b) => a.lengthCut - b.lengthCut);
        return data;
      })
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },
};

export default ProductsData;
